






































import mixins from 'vue-typed-mixins'
import VisibleColumns from '@/abstract/VisibleColumns'
import iconArrowUp from '@/assets/svg/rounded/arrow-up.svg?inline'
import { DataTableColumnItem } from '@/models/dataTable'
import { ESortDir, DEFAULT_SORT_DIR } from '@/constants/dataTable'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import AllChecking from '@/components/DataTable/DataTableAllChecking.vue'
import PageChecking from '@/components/DataTable/DataTablePageChecking.vue'
import ColumnSorting from '@/components/DataTable/Columns/ColumnSorting.vue'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'

const toggleSortDirection = (direction: ESortDir): ESortDir => {
  return direction === ESortDir.ASC ? ESortDir.DESC : ESortDir.ASC
}

export interface Sorting {
  key: string
  direction: ESortDir
}

interface Props {
  columns: Array<DataTableColumnItem>
  allColumns: Array<DataTableColumnItem>
  isCheckedAll: boolean
  allCheckedOnPage: boolean
  partialCheckedOnPage: boolean
  showAllChecking: boolean
  tableData: boolean
  partialCheckedOnAllPage: boolean
  directory: string
  enableChecking: boolean
}

interface Data {
  sort: Sorting
  showColumnSort: boolean
}

interface Methods {
  changeSort: (newSortBy: string) => void
  setIconClass: (colName: string) => string
  setSort: () => void
  showAllCheck: (status: boolean) => void
  checkAllOnPage: (status: boolean) => void
  checkAllOnAllPage: (status: boolean) => void
}

interface Computed {
  tcDirectory: string
}

export default mixins(VisibleColumns).extend<Data, Methods, Computed, Props>({
  components: {
    iconArrowUp,
    PaidLabel,
    AllChecking,
    PageChecking,
    ColumnSorting,
    iconCaretDown,
  },
  props: {
    columns: {
      required: true,
    },
    allColumns: {
      required: true,
    },
    isCheckedAll: {
      required: true,
    },
    allCheckedOnPage: {
      required: true,
    },
    partialCheckedOnPage: {
      required: true,
    },
    partialCheckedOnAllPage: {
      required: true,
    },
    showAllChecking: {
      required: true,
    },
    tableData: {
      required: true,
    },
    directory: {
      required: true,
    },
    enableChecking: {
      required: true,
    },
  },
  data() {
    return {
      sort: {
        key: '',
        direction: DEFAULT_SORT_DIR,
      },
      showColumnSort: false,
    }
  },
  methods: {
    changeSort(key) {
      this.sort = {
        key: key,
        direction:
          this.sort.key === key
            ? toggleSortDirection(this.sort.direction)
            : DEFAULT_SORT_DIR,
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          sort: `${this.sort.key}:${this.sort.direction}`,
        },
      })
    },
    setIconClass(colName) {
      if (this.sort.key === colName) {
        return this.sort.direction
      }
      return ''
    },
    setSort() {
      if (this.$route.query.sort) {
        const querySort = this.$route.query.sort as string
        this.sort.key = querySort.split(':')[0]
        this.sort.direction = querySort.split(':')[1] as ESortDir
      }
    },
    showAllCheck(status) {
      this.$emit('show-all-check', status)
    },
    checkAllOnPage(status) {
      this.$emit('input', status)
    },
    checkAllOnAllPage(status) {
      this.$emit('check-all-on-all-page', status)
    },
  },
  computed: {
    tcDirectory() {
      return this.directory.toLowerCase()
    },
  },
  mounted() {
    this.setSort()
  },
  watch: {
    '$route.query.sort'() {
      this.setSort()
    },
  },
})
